var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ceshi-body"},[_c('el-upload',{attrs:{"action":"cdn.bosscaigou.com","accept":".xlsx,.xls","http-request":_vm.uploadFile,"limit":1,"show-file-list":false}},[_c('el-button',{attrs:{"type":"warning"}},[_vm._v("点击上传")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }